export const Actions = {
  SET_LOADING: 'SET_LOADING',
  SET_CURRENT_AGENT: 'SET_CURRENT_AGENT',
  SET_ORIGINAL_AGENT: 'SET_ORIGINAL_AGENT',
  SET_AGENCY: 'SET_AGENCY',
  SET_AGENTS: 'SET_AGENTS',
  RESET: 'RESET',
  SHOW_RENEWALS_BANNER: 'SHOW_RENEWALS_BANNER:',
};
